export const emailSubscriptionUrl = $('html').data('email-subscribe-url');

jQuery(document).ready(function($){
	//hide the subtle gradient layer (.pricing-list > li::after) when pricing table has been scrolled to the end (mobile version only)
	checkScrolling($('.pricing-body'));
	$(window).on('resize', function(){
		window.requestAnimationFrame(function(){checkScrolling($('.pricing-body'))});
	});
	$('.pricing-body').on('scroll', function(){ 
		var selected = $(this);
		window.requestAnimationFrame(function(){checkScrolling(selected)});
	});

	function checkScrolling(tables){
		tables.each(function(){
			var table= $(this),
				totalTableWidth = parseInt(table.children('.pricing-features').width()),
		 		tableViewport = parseInt(table.width());
			if( table.scrollLeft() >= totalTableWidth - tableViewport -1 ) {
				table.parent('li').addClass('is-ended');
			} else {
				table.parent('li').removeClass('is-ended');
			}
		});
	}

	//switch from monthly to annual pricing tables
	bouncy_filter($('.pricing-container'));

	function bouncy_filter(container) {
		container.each(function(){
			var pricing_table = $(this);
			var filter_list_container = pricing_table.children('.pricing-switcher'),
				filter_radios = filter_list_container.find('input[type="radio"]'),
				pricing_table_wrapper = pricing_table.find('.pricing-wrapper');

			//store pricing table items
			var table_elements = {};
			filter_radios.each(function(){
				var filter_type = $(this).val();
				table_elements[filter_type] = pricing_table_wrapper.find('li[data-type="'+filter_type+'"]');
			});

			//detect input change event
			filter_radios.on('change', function(event){
				event.preventDefault();
				//detect which radio input item was checked
				var selected_filter = $(event.target).val();

				//give higher z-index to the pricing table items selected by the radio input
				show_selected_items(table_elements[selected_filter]);

				//rotate each pricing-wrapper 
				//at the end of the animation hide the not-selected pricing tables and rotate back the .pricing-wrapper
				
				if( !Modernizr.cssanimations ) {
					hide_not_selected_items(table_elements, selected_filter);
					pricing_table_wrapper.removeClass('is-switched');
				} else {
					pricing_table_wrapper.addClass('is-switched').eq(0).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {		
						hide_not_selected_items(table_elements, selected_filter);
						pricing_table_wrapper.removeClass('is-switched');
						//change rotation direction if .pricing-list has the .bounce-invert class
						if(pricing_table.find('.pricing-list').hasClass('bounce-invert')) pricing_table_wrapper.toggleClass('reverse-animation');
					});
				}
			});
		});
	}
	function show_selected_items(selected_elements) {
		selected_elements.addClass('is-selected');
	}

	function hide_not_selected_items(table_containers, filter) {
		$.each(table_containers, function(key, value){
	  		if ( key != filter ) {	
				$(this).removeClass('is-visible is-selected').addClass('is-hidden');

			} else {
				$(this).addClass('is-visible').removeClass('is-hidden is-selected');
			}
		});
	}
	
 




  var a = $("#id_email").val();
  var error_form_type = $("#id_form_error").val();
  console.log("Subcriber clicked", a, error_form_type)
  if (error_form_type === "BASIC PLAN" )
  {
    document.getElementById("BASIC_PLAN").click();
  }else if(error_form_type === "ECHO PLAN"){
    document.getElementById("ECHO_PLAN").click();  
  }else if(error_form_type === "PRO PLAN"){
    document.getElementById("PRO_PLAN").click();  
  }else if(error_form_type === "BUSINESS PLAN"){
    document.getElementById("BUSINESS_PLAN").click();  
  }

 var  errorMsg = $('.email-subscription-error-alert');  
  var closeMsg = $('.close-msg-error');
  closeMsg.on('click', (e) => {
    errorMsg.addClass('d-none');
  });

 var  erroroneMsg = $('.email-subscription-error-one-alert');  
  var closeMsgone = $('.close-msg-error');
  closeMsgone.on('click', (e) => {
    erroroneMsg.addClass('d-none');
  });

  
  var  successMsg = $('.email-subscription-success-alert'); 
  var closeMsgSuccess = $('.close-msg-success');
  closeMsgSuccess.on('click', (e) => {
    successMsg.addClass('d-none');
  });
  
$('#email-subsciption-form').on('submit', function(event){
        event.preventDefault();
	    console.log("email-subsciption-form ajax")
        $.ajax({
        url: emailSubscriptionUrl,
        method: 'POST',
        data: {email:$("#id_email").val(),type:$("#plan").val(), org_type:$("#org_type").val()},
        success: function(response){
		  console.log("Raju Sucess")
		  console.log(response['success'])
          //$("#results").replaceWith("<li><strong>"+response['success']+"</strong> </li>");       
           errorMsg.addClass('d-none');	
           erroroneMsg.addClass('d-none');			   
           successMsg.removeClass('d-none');			   
        },
        error: function(response) {
		  console.log(response.responseJSON['error'])
		  console.log("Raju Error")
		  var str =response.responseJSON['error']
          //$("#results").replaceWith("<li><strong>"+response.responseJSON['error']+"</strong> </li>");	
		  if (str.includes("valid") == true){
           errorMsg.addClass('d-none');	
           erroroneMsg.removeClass('d-none');	   
		   }else{
           erroroneMsg.addClass('d-none');		   
           errorMsg.removeClass('d-none');
           }		   
           successMsg.addClass('d-none');		   
        }
      });
});
 

	
});
